//
import { SaveOutlined } from '@mui/icons-material';
import { Button, List, ListItem, Stack, Switch, ToggleButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { InitFailed } from 'src/basic-components/init-failed';
import { Loading } from 'src/basic-components/loading';
import T from 'src/basic-components/text';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Page from 'src/components/Page';
import { useApi } from 'src/contexts/api-provider';
import { PATH_DASHBOARD } from 'src/routes/paths';

export default function AdminSettingsApp() {
  const [loading, setLoading] = useState(false);

  const [model, setModel] = useState();

  const [selectedRow, setSelectedRow] = useState();
  const { CoreApi } = useApi();
  const apiName = 'adminSettingsApi';

  const api = {
    initSettings: CoreApi(apiName, 'initSettings'),
    saveSetting: CoreApi(apiName, 'saveSetting'),
  };

  const loadSettings = () => {
    setLoading(true);
    api
      .initSettings()
      .then(setModel)
      .catch(setModel)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (model) return;
    loadSettings();
  }, [model]);

  if (!model) return <Loading />;
  if (model instanceof Error) return <InitFailed ex={model} onRetry={() => setModel(null)} />;

  const handleAllowModifyAccountByUsers = (event) => {
    const allow = event.target.checked;
    const newModel = { ...model, allowModifyAccountByUsers: allow };
    setModel(newModel);
  };

  const saveChanges = () => {
    setLoading(true);
    api
      .saveSetting(model)
      .then(setModel)
      .catch(setModel)
      .finally(() => setLoading(false));
  };

  return (
    <Page
      as="subtitle1"
      title="admin-settings"
      elevation={5}
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[
            { name: 'dashboard', href: PATH_DASHBOARD.root },
            { name: 'admin-settings', href: PATH_DASHBOARD.settings.root },
          ]}
        />
      }
      Control={
        <Button size="small" variant="outlined" onClick={saveChanges} endIcon={<SaveOutlined />}>
          <T>save</T>
        </Button>
      }
    >
      <List>
        <ListItem>
          <Stack flex flexDirection="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
            <T>allow-modify-account-by-users</T>

            <Switch
              disabled={loading}
              checked={model.allowModifyAccountByUsers}
              onChange={handleAllowModifyAccountByUsers}
            />
          </Stack>
        </ListItem>
      </List>
    </Page>
  );
}
